'use strict';

exports.__esModule = true;
// Generated by CoffeeScript 1.12.6
var subscribeObserverAdapter;

exports.default = subscribeObserverAdapter = function (subscribe) {
  return function (onNextOrObserver, onError, onComplete) {
    if (typeof onNextOrObserver === 'function') {
      return subscribe({
        next: onNextOrObserver,
        error: onError,
        complete: onComplete
      });
    } else {
      return subscribe(onNextOrObserver);
    }
  };
};